export default __webpack_public_path__ + "img/c1cc865df6f429d353b2170df40baa33.png";